<template>
  <div v-if="showBanner" class="color-box yellow">
    <Icon icon="error" />
    <p>{{ $t('PUBLISHING.LIST.REVIEW_SLOW') }}</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';
import { DMS_GROUPS } from 'commons/api/models/dms/dmsStates.ts';
import { usePublishingStore } from 'commons/stores/publishing.ts';
import { useCompositionsStore } from 'commons/stores/compositions';
import { COMPOSITION_POS_STATES } from 'commons/api/models/publishingCore/compositionPosStates.ts';

const store = useStore();
const { isMpScope } = usePublishingStore();
const compositionsStore = useCompositionsStore();

const showBanner = computed(() => {
  const isStarter = store.getters['dms/currentGroup'] === DMS_GROUPS.STARTER;

  const hasDesignInReview =
    compositionsStore.posStateCounts.stateCounts[
      COMPOSITION_POS_STATES.PENDING.key
    ] > 0;

  return isMpScope && isStarter && hasDesignInReview;
});
</script>

<style scoped lang="scss">
.color-box {
  display: flex;
  align-items: center;
  text-align: center;
  gap: 8px;

  p {
    margin: 0;
  }

  .icon {
    height: 24px;
    width: 24px;
  }
}
</style>
